export const baseEnvironment = {
  bloatwareActive: true, // if true, bloatware like ads, tracker and 3rd party scripts will be loaded
  surrogateKeyPrefixActive: true,
  env: 'base',
  production: true, // must be true for all production-environments, will ignore hostname if true !!
  hostname: '',
  payment_hostname: '',
  mention_me_refereefind_enabled: false,
  sentry_enabled: true,
  platformFallback: 'ar',
  datepicker: {
    start_offset_in_days: 2,
    range_of_days: 2,
    summer_start: '05-01',
    summer_end: '12-13',
    summer_default_date: '12-20',
    summer_range_of_days: 7
  },
  sales: [
    {
      // ALPY: automatic black coloring in black week
      name: 'blackFriday',
      platforms: ['ar'],
      upToDiscount: 70, // advertised 'up to' discount on startpage
      startPageTitleTranskey: 'headlineBlack',
      townPageTitleTranskey: 'noTeaserHeadlineBlack', // BLACK WEEK: Save now..
      colors: {
        '--primary-slate-color': '#000',
        '--secondary-slate-color': '#000'
      }
    },
    {
      // OTHERS: only increase discount number
      name: 'blackFriday',
      platforms: ['s2', 'sb', 'sf', 'pf', 'sm', 'mc', 'df', 'du', 'bp', 'es'],
      upToDiscount: 70 // advertised 'up to' discount on startpage
    },
    {
      name: 'cyberMonday',
      platforms: ['ar', 's2', 'sb', 'sf', 'pf', 'sm', 'mc', 'df', 'du', 'bp', 'es'],
      upToDiscount: 70,
      startPageTitleTranskey: 'headlineCyber',
      townPageTitleTranskey: 'noTeaserHeadlineCyber' // CYBER MONDAY: Save now..
    }
  ],
  language: {
    selection_names: {
      de: 'Deutsch',
      en: 'English',
      fr: 'Français',
      it: 'Italiano',
      nl: 'Nederlands',
      es: 'Español',
      cs: 'Čeština',
      pl: 'Polski',
      sk: 'Slovak',
      da: 'Dansk'
    }
  },
  // used to load locale files in browser
  language_path: '/assetz',
  // used to load locale files on server (SSR)
  language_path_server: 'http://localhost:4200/assetz',
  api: {
    url: {
      // sentry config
      getSentryTracingConfig: '/components/sentry',
      getDistanceMatrixApi: '/components/distance-matrix',
      getCustomerGeoIpCountryCode: 'service/geoip/country',
      getOffers: '%lang%/service/ski-rental/offer',
      getPlatformInformation: '%lang%/service/static/%partner%/platform-information',
      getTown: '%lang%/service/saleslocation?slug=%slug%&businessPartnerType=ski-hire',
      getShops: '%lang%/service/ski-rental/shops/search?townSlug=%slug%&currencyCode=%currency%',
      getLocationBySlug: '%lang%/service/ski-rental/shop?slug=%slug%',
      getAutocomplete: '%lang%/service/static/search/autocomplete/skihire?query=%query%',
      getAutocompleteReferer:
        '%lang%/service/static/search/autocomplete-referer/%refererId%/skihire?query=%query%',
      getPromotionCode: '%lang%/service/ski-rental/promotioncode/%PROMOCODE%',
      getCart: '%lang%/service/cart/current',
      getDiscountCountdowns: '%lang%/service/static/ski-rental/discount-countdowns',
      getPartnerRefererInfo: '%lang%/service/static/partnerreferer/%identifier%/info',
      getRatingApi: '%lang%/service/static/order/rating-statistic/%date%',
      getPaymentMethodsApi: '%lang%/service/payment/methods',
      getShopRatingsApi: '%lang%/service/static/order/shop-ratings',
      getZoomInApi: '%lang%/service/zoomin',
      getCheckCouponCodeApi: 'en/service/payment/check-coupon/%code%',
      getAddCouponCodeApi: 'en/service/cart/%cid%/add-coupon',
      getRemoveCouponCodeApi: 'en/service/cart/%cid%/remove-coupon',
      postPartnerContactApi: 'en/partnerdata',

      // ski course
      getAutocompleteCoursePoi: 'service/ski-school/ski-pro/autocomplete?culture=%culture%&query=%query%',

      // shop rating
      getShopRatingApi: 'en/service/customer/ratings/rateshop/%cryptedKey%',
      postShopRatingApi: 'en/service/customer/ratings',

      // product selection
      getLocationByIdParnterApi: '%lang%/service/ski-rental/%partner%/shops/%id%?currencyCode=%currency%',
      getLocationByIdApi: '%lang%/service/ski-rental/shops/%id%?currencyCode=%currency%',
      getProductsForShopApi:
        '%lang%/service/static/ski-rental/shops/%id%/products?currency=EUR&duration=%duration%',
      postAddProductToCart: '%lang%/service/ski-rental/%partnerUrl%/cart/products?cid=%cid%',
      deleteRemoveProductFromCart: '%lang%/service/cart/%partnerUrl%/%cid%/items/%itemId%',
      deleteRemoveAllProductsFromCart: '%lang%/service/cart/%partnerUrl%/%cid%/items',
      postCreateCart: '%lang%/service/%partnerUrl%/cart',
      postUpdateCart: '%lang%/service/cart/%partnerUrl%/%cid%?shopId=%shopId%',
      getCartByCid: '%lang%/service/cart/%partnerUrl%/%cid%',
      postAddPersonToCart: '%lang%/service/cart/%partnerUrl%/%cartid%/people',
      putUpdatePersonInCart: '%lang%/service/cart/%partnerUrl%/%cartid%/people/%id%',
      deletePersonFromCart: '%lang%/service/cart/%partnerUrl%/%cartid%/people/%id%',
      getPriceInfo: '%lang%/service/ski-rental/%partnerUrl%/shops/%shopId%/priceinfo?cid=%cid%',
      postCartCopy: '%lang%/service/cart/copy?cid=%cid%',
      getCartCopy: '%lang%/service/cart/copy?id=%id%',
      postCopyPerson: '%lang%/service/cart/%cid%/people/%personId%/copy',

      // confirmation

      getConfirmationDataApi: '%lang%/service/payment/confirmation-data',
      getOrder: '%lang%/service/order/current?cartKey=%cid%',

      // checkout
      postRegisterData: '%lang%/service/customer/register?cid=%cid%',
      putPaymentTypeApi: '%lang%/service/payment/type?cid=%cid%',
      postGuarantyData: '%lang%/service/cart/%cid%/guaranty',
      postInsuranceData: '%lang%/service/cart/%cid%/insurance',
      postNotifyCouponPayment: '%lang%/service/payment/notify/coupon-payment',
      postPermissionMarketingSetting: '%lang%/service/cart/%cid%/marketing',

      // static pages (legal text walls)
      getStaticText: '%lang%/service/static/page?page_type=%type%&platform=%platform%',

      // for micro sites
      getPartnerPlatformInformation: 'en/service/static/%partner%/platform-information',
      getTopCountries: 'service/search/topcountries',
      getTopTowns: 'service/search/toptowns',
      getReportPaymentSuccessUrl: '%lang%/service/payment/%partner%/checkout/success',
      // for micro sites - start
      getMicrositeConfigApi: '%lang%/service/static/microsite-config/%partner%',
      getPartnerUnbookableInfo: 'service/ski-rental/%partner%/unbookable-shops-info',
      getPartnerOffers: '%lang%/service/ski-rental/%partner%/offer',
      getPartnerShops:
        '%lang%/service/ski-rental/%partner%/shops/search?townSlug=%slug%&currencyCode=%currency%',
      getPartnerPromoCode: '%lang%/service/ski-rental/%partner%/promotioncode/%PROMOCODE%',
      getPartnerCart: '%lang%/service/cart/%partner%/current',
      getPartnerDiscountCountdowns: '%lang%/service/static/ski-rental/%partner%/discount-countdowns',
      postPartnerPaymentProviderIFrameApi: '%lang%/service/payment/%partner%/iframe_url?cid=%cid%',
      getPartnerProductsForShopApi:
        '%lang%/service/static/ski-rental/%partner%/shops/%id%/products?currency=EUR&duration=%duration%',
      // for micro sites - end
      // swisspass
      postSwisspassDataApi: '%lang%/service/swisspass/validate_id',
      postSwisspassCreatePromotion: '%lang%/service/swisspass/create_promotion',

      // customer account api
      getValidateCustomerTokenApi: 'customer-backend/login',
      postRequestNewTokenApi: '%lang%/customer-backend/login',
      getBookingsPerUser: 'customer-backend/my-account/bookings',
      putFullCancellation: 'customer-backend/my-account/cancel-order/%globalId%',
      postLogoutEverywhere: 'customer-backend/my-account/logout-everywhere',
      deleteUserAccountApi: 'customer-backend/my-account/delete-account',
      // customer account contacts CRUD
      getContactsForUsersApi: 'api/customer-account/users/%userId%/contacts',
      createContactForUserApi: 'api/customer-account/contacts',
      updateContactForUserApi: 'api/customer-account/contacts/%contactId%',
      deleteContactForUserApi: 'api/customer-account/contacts/%contactId%',

      // customer account settings API
      getCustomerAccountSettingsForUsersApi: 'api/customer-account/users/%userId%/settings',
      getCustomerAccountSettings: 'api/customer-account/settings/%settingId%',
      createCustomerAccountSettings: 'api/customer-account/settings',
      updateCustomerAccountSettings: 'api/customer-account/settings/%settingId%',
      deleteCustomerAccountSettings: 'api/customer-account/settings/%settingId%',

      // cancellation requests
      postCancellationRequestApi: 'service/cancellation/request',

      // ODIN payment
      initializePayment: 'api/payment/initialize',
      checkPaymentStatus: 'api/payment/check-status/%orderId%',
      getPaymentmethods: 'api/payment/methods/%platform%/%lang%/%currency%',

      // MentionMe
      mentionMeURL: 'https://tag.mention-me.com/api/v2'
    }
  },
  platform: {
    ar: {
      acceptedLanguages: ['de', 'en', 'fr', 'it', 'nl', 'sk', 'cs', 'pl', 'es', 'da']
    },
    sb: {
      acceptedLanguages: ['en']
    },
    s2: {
      acceptedLanguages: ['fr']
    },
    sf: {
      acceptedLanguages: ['en']
    },
    pf: {
      acceptedLanguages: ['de']
    },
    sm: {
      acceptedLanguages: ['fr']
    },
    mc: {
      acceptedLanguages: ['fr']
    },
    df: {
      acceptedLanguages: ['fr']
    },
    du: {
      acceptedLanguages: ['en']
    },
    bp: {
      acceptedLanguages: ['en']
    }
  }
};
